//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { ShareOnboardingActionType } from '@share/actions/shareOnboardingActions';
import { SHARE_ACTIONS, ShareOnboardingSteps } from '@share/constants/shareConstants';
import { IShareOnboarding } from '@share/models/shareStateModel';

const initialState: IShareOnboarding = {
  currentOnboardingStep: ShareOnboardingSteps.REVIEW,
  shouldShowOnboarding: false,
  isStyleGuideReviewed: false,
  shouldShowSourceError: false,
  shouldShowStyleGuideAcceptanceError: false,
};

export default function ShareOnboardingReducer(
    state: IShareOnboarding = initialState,
    action: ShareOnboardingActionType,
) {
  switch (action.type) {
    case SHARE_ACTIONS.UPDATE_SHOULD_SHOW_ONBOARDING:
      return {
        ...state,
        shouldShowOnboarding: action.shouldShowOnboarding,
      };
    case SHARE_ACTIONS.UPDATE_CURRENT_ONBOARDING_STEP:
      return {
        ...state,
        currentOnboardingStep: action.currentOnboardingStep,
      };
    case SHARE_ACTIONS.UPDATE_IS_STYLE_GUIDE_REVIEWED:
      return {
        ...state,
        isStyleGuideReviewed: action.isStyleGuideReviewed,
      };
    case SHARE_ACTIONS.UPDATE_SHOULD_SHOW_STYLE_GUIDE_ACCEPTANCE_ERROR:
      return {
        ...state,
        shouldShowStyleGuideAcceptanceError: action.shouldShowStyleGuideAcceptanceError,
      };
    case SHARE_ACTIONS.UPDATE_SHOULD_SHOW_SOURCE_ERROR:
      return {
        ...state,
        shouldShowSourceError: action.shouldShowSourceError,
      };
    default:
      return state;
  }
}
